import { useUpdateToCart as useUpdateToCartCore } from '@ztechapps/order.common'
import { routesDef } from '../config/routes'
import { useUser } from './useUser'
import { useAlertDialog, useError, useHistory } from '@ztechapps/common.hook'

export const useUpdateToCart = () => {
  const { updateToCart, loading, error } = useUpdateToCartCore()
  const history = useHistory()
  const { onError } = useError()
  const { loggedIn } = useUser()
  const { alert } = useAlertDialog({
    text: 'You need to login first before adding item to your cart.',
    title: 'Login first!',
  })

  const onClick = async ({ itemId, orderId, quantity }) => {
    if (loading) return

    if (!loggedIn) {
      await alert()
      return history.push(routesDef.LoginPage.altPath())
    }

    try {
      await updateToCart({ itemId, orderId, quantity })
    } catch (error) {
      onError(error)
      throw error
    }
  }

  return { updateToCart: onClick, loading, error }
}
